import React, { useEffect, useState } from 'react';
import style from '../../assets/css/UserList.module.css';
import CommonPopupForm from './CommonPopupForm';
import { createPromotions, fetchPromotions, deletePromotion, editPromotions } from '../../../services/customOffers';
import { toast } from 'react-toastify';
import { fetchMedicalCategories } from '../../../services';
import axios from 'axios';
import Select from 'react-select';

function Promotions() {
    const [isOpen, setIsOpen] = useState(false);
    const [img, setImg] = useState(null);
    const [categories, setCategories] = useState([]);
    const [formData, setFormData] = useState({
        image: null,
        title: "",
        description: "",
        code: "",
        key_points: [],
        start_date: "",
        end_date: "",
        offer_percentage_min: "",
        offer_percentage_max: "",
    });
    const [promotions, setPromotions] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [categoriesData, setCategoriesData] = useState([]);
    const [equipments, setEquipments] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [formCategoryData, setFormCategoryData] = useState({
        category: "",
        subcategory: "",
        equipment: ""
    });



    // const handleChangeCategory = (e) => {
    //     const { name, value } = e.target;


    // };

    const getEquipments = async (categoryId, subcategoryId) => {
        try {
            const params = new URLSearchParams();
            if (categoryId) params.append('department_categories', categoryId);
            if (subcategoryId) params.append('subcategories', subcategoryId);

            const response = await fetch(
                `https://api.avyayam.in/api/v1/product/filter-options/?${params.toString()}`,
                {
                    method: 'GET',
                    headers: {
                        'accept': 'application/json'
                    }
                }
            );
            const res = await response.json();
            // console.log("response", res.results);
            setEquipments(res?.results || []);
        } catch (error) {
            console.error("Failed to fetch equipments", error);
        }
    };

    const getPromotions = async () => {
        try {
            const res = await fetchPromotions();
            // console.log(res?.data?.data)
            setPromotions(res?.data?.data)
        } catch (error) {
            console.error(error);
        }
    }
    const getCategory = async () => {
        try {
            const res = await fetchMedicalCategories();

            setCategories(res?.data?.data || []);
        } catch (error) {
            console.error(error);
        }
    }


    useEffect(() => {
        getPromotions();
        getCategory();
    }, [])


    const handleChange = (e) => {
        const { value, name } = e.target;

        if (name === "category") {
            const selectedCategory = categories.find((cat) => cat.id === parseInt(value));
            const subList = selectedCategory?.subcategories || [];
            const firstSubId = subList[0]?.id || "";

            setSubcategories(subList);

            setFormCategoryData((prev) => ({
                ...prev,
                category: value,
                subcategory: firstSubId,
                equipment: "", // Reset equipment on category change
            }));

            if (firstSubId) {
                getEquipments(parseInt(value), parseInt(firstSubId));
            }
        } else if (name === "subcategory") {
            setFormCategoryData((prev) => ({
                ...prev,
                subcategory: value,
                equipment: "", // Reset equipment on subcategory change
            }));

            if (formCategoryData.category) {
                getEquipments(parseInt(formCategoryData.category), parseInt(value));
            }
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
            setFormCategoryData((prev) => ({ ...prev, [name]: value }));
        }
    };


    const handleImage = (e) => {
        const file = e.target.files[0]; // Corrected this line
        if (file) {
            setImg(file);
            setFormData({ ...formData, image: file }); // Update formData.image as well
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const formDataToSend = new FormData();
            const keyPointsArray = formData.key_points
                .split(',')
                .map(item => item.trim())
                .filter(item => item !== '');

            formDataToSend.append('key_points', JSON.stringify(keyPointsArray));
            formDataToSend.append('title', formData.title);
            formDataToSend.append('description', formData.description);
            formDataToSend.append('code', formData.code);
            formDataToSend.append('start_date', formData.start_date);
            formDataToSend.append('end_date', formData.end_date);
            formDataToSend.append('offer_percentage_min', formData.offer_percentage_min);
            formDataToSend.append('offer_percentage_max', formData.offer_percentage_max);
            formDataToSend.append('category', formCategoryData.category);
            formDataToSend.append('subcategory', formCategoryData.subcategory);
            formDataToSend.append('equipment', formCategoryData.equipment);

            if (formData.image) {
                formDataToSend.append('image', formData.image);
            }

            let response;
            if (editingId) {
                response = await editPromotions(editingId, formDataToSend);
                await axios.post('https://api.avyayam.in/api/v1/product/promotion-assignment/', {
                    promotion: editingId,
                    product: formCategoryData.equipment,
                    dept_category: formCategoryData.category,
                    subcategory: formCategoryData.subcategory
                });
            } else {
                response = await createPromotions(formDataToSend);

                if (response?.status_code === 201) {
                    await axios.post('https://api.avyayam.in/api/v1/product/promotion-assignment/', {
                        promotion: response?.data?.data?.uid,
                        product: formCategoryData.equipment,
                        dept_category: formCategoryData.category,
                        subcategory: formCategoryData.subcategory
                    });
                }
            }

            if (response) {
                toast.success("Promotion saved successfully");
                getPromotions();
                setIsOpen(false);
                setImg(null);
                setFormData({
                    image: null,
                    title: "",
                    description: "",
                    code: "",
                    key_points: "",
                    start_date: "",
                    end_date: "",
                    offer_percentage_min: "",
                    offer_percentage_max: "",
                });
                setEditingId(null);
                setFormCategoryData({
                    category: "",
                    subcategory: "",
                    equipment: ""
                });
                getPromotions(); // refresh
            }
        } catch (error) {
            const message = error?.response?.data?.message || "Something went wrong!";
            toast.error(message);
            console.error(message);
        }
    };


    // console.log("dk", promotions);
    const handleEdit = (item) => {
        // console.log("first", item.uid);
        setEditingId(item.uid); // store the ID for editing
        setImg(item.image); // optional: image preview
        setFormData({
            image: null,
            title: item.title || "",
            description: item.description || "",
            code: item.code || "",
            key_points: Array.isArray(item.key_points) ? item.key_points.join(', ') : "",
            start_date: item.start_date?.slice(0, 10) || "",
            end_date: item.end_date?.slice(0, 10) || "",
            offer_percentage_min: item.offer_percentage_min || "",
            offer_percentage_max: item.offer_percentage_max || "",
        });
        setIsOpen(true);
    };

    const handleDelete = async (id) => {
        try {
            const res = await deletePromotion(id);
            if (res) {
                toast.success("promotion deleted successfully!")
                getPromotions()
            }
        } catch (error) {
            console.error(error)
        }
    };
    const categoryOptions = categories.map((cat) => ({
        value: cat.id,
        label: `${cat.name} / ${cat.med_department_detail?.name || ''}`,
    }));
    return (
        <div>
            <div className='flex items-center justify-between my-6'>
                <h1 className='font-bold text-3xl'>Promotions</h1>
                <button
                    className="bg-[#019c89] text-white px-4 py-2 rounded"
                    onClick={() => setIsOpen(true)}
                >
                    Add
                </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {promotions?.map((item, index) => (
                    <div
                        key={index}
                        className="bg-white rounded-3xl shadow-lg border border-gray-200 hover:shadow-xl hover:border-blue-400 transition-all duration-300 transform hover:scale-[1.02] flex flex-col"
                    >
                        <img
                            src={item.image}
                            alt="Promotion"
                            className="w-full h-48 object-cover rounded-t-3xl"
                        />

                        {/* Card Body */}
                        <div className="p-5 flex flex-col justify-between flex-1">
                            {/* Top Content */}
                            <div>
                                <h2 className="text-xl font-bold text-gray-800 mb-2 line-clamp-2">
                                    {item.title}
                                </h2>
                                <p className="text-sm text-blue-500 font-semibold mb-3">
                                    Code: <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded">{item.code}</span>
                                </p>

                                <div className="flex justify-between text-sm mb-3">
                                    <span className="bg-green-100 text-green-700 px-2 py-1 rounded-full">
                                        Min: {item.offer_percentage_min}%
                                    </span>
                                    <span className="bg-yellow-100 text-yellow-700 px-2 py-1 rounded-full">
                                        Max: {item.offer_percentage_max}%
                                    </span>
                                </div>

                                <p className="text-gray-600 text-sm mb-3 line-clamp-3">{item.description}</p>

                                <div className="mb-4">
                                    <p className="text-sm font-semibold text-gray-700 mb-1">Key Points:</p>
                                    <ul className="list-disc list-inside text-sm text-gray-600 space-y-1 max-h-[100px] overflow-y-auto scrollbar-thin scrollbar-thumb-blue-300 pr-1">
                                        {item?.key_points?.map((point, idx) => (
                                            <li key={idx}>{point}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            {/* Buttons */}
                            <div className="flex justify-end space-x-2 pt-4 mt-auto">
                                <button
                                    onClick={() => handleEdit(item)}
                                    className="px-4 py-2 text-sm text-white bg-gradient-to-r from-blue-500 to-blue-700 rounded-full hover:from-blue-600 hover:to-blue-800 transition"
                                >
                                    Edit
                                </button>
                                {/* <button
                                    onClick={() => handleDelete(item.uid)}
                                    className="px-4 py-2 text-sm text-white bg-gradient-to-r from-red-500 to-red-700 rounded-full hover:from-red-600 hover:to-red-800 transition"
                                >
                                    Delete
                                </button> */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* input forms  */}

            <CommonPopupForm
                title="Add Promotions"
                isOpen={isOpen}
                // onClose={() => setIsOpen(false)}
                onClose={() => {
                    setIsOpen(false);
                    setEditingId(null);
                    setImg(null);
                    setFormData({
                        image: null,
                        title: "",
                        description: "",
                        code: "",
                        key_points: "",
                        start_date: "",
                        end_date: "",
                        offer_percentage_min: "",
                        offer_percentage_max: "",
                    });
                    setFormCategoryData({
                        category: "",
                        subcategory: "",
                        equipment: ""
                    })
                }}
                onSubmit={handleSubmit}
            >
                {/* Scrollable content container */}
                <div className="space-y-6 overflow-y-auto max-h-[65vh] px-4 py-2">



                    {/* Image Upload */}
                    <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">Promotion Image</label>
                        <input
                            type="file"
                            name="image"
                            onChange={handleImage}
                            accept="image/*"
                            className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                        />
                        {img && (
                            <img
                                src={typeof img === 'string' ? img : URL.createObjectURL(img)}
                                alt="Preview"
                                className="w-32 h-32 object-cover mt-2 rounded border"
                            />
                        )}
                    </div>

                    <div>
                        <h2 className="text-lg font-semibold text-gray-800 mb-4">Promotions Specific Category</h2>
                    </div>

                    <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4'>
                        {/* Category Dropdown */}
                        {/* <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">Category</label>
                            <select
                                name="category"
                                value={formCategoryData.category}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                            >
                                <option value="">Select Category</option>
                                {categories.map((cat) => (
                                    <option key={cat.id} value={cat.id}>
                                        {cat.name} <span>/ {cat.med_department_detail.name}</span>
                                    </option>
                                ))}
                            </select>
                        </div> */}

                        <div className="space-y-2 ">
                            <label className="block text-sm font-medium text-gray-700 ">Category</label>
                            <Select
                                options={categoryOptions}
                                value={categoryOptions.find(option => option.value === formCategoryData.category)}
                                onChange={(selectedOption) =>
                                    handleChange({
                                        target: {
                                            name: 'category',
                                            value: selectedOption ? selectedOption.value : '',
                                        },
                                    })
                                }
                                placeholder="Select Category"
                                className="react-select-container"
                                classNamePrefix="react-select"
                                isClearable
                            />
                        </div>


                        {/* Subcategory Dropdown */}
                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">Subcategory</label>
                            <select
                                name="subcategory"
                                value={formCategoryData.subcategory}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                            >
                                <option value="">Select Subcategory</option>
                                {subcategories.map((sub) => (
                                    <option key={sub.id} value={sub.id}>
                                        {sub.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Equipments Dropdown */}
                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">Equipment</label>
                            <select
                                name="equipment"
                                value={formCategoryData.equipment || ""}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                            >
                                <option value="">Select Equipment</option>
                                {equipments.map((eq) => (
                                    <option key={eq.id} value={eq.id}>
                                        {eq.equip_name}
                                    </option>
                                ))}
                            </select>
                        </div>

                    </div>

                    {/* Grid Inputs */}
                    <div className="grid lg:grid-cols-2 gap-6">
                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">Title</label>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                placeholder="Title"
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                            />
                        </div>

                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">Description</label>
                            <input
                                type="text"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                placeholder="Description"
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                            />
                        </div>

                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">Promo Code (unique)</label>
                           
                            <input
                                type="text"
                                name="code"
                                value={formData.code}
                                onChange={handleChange}
                                placeholder="Promo Code"
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                            />
                        </div>

                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">Key Points</label>
                            <input
                                type="text"
                                name="key_points"
                                value={formData.key_points} // Show as comma-separated string
                                onChange={handleChange}
                                placeholder="Key Points (comma separated)"
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                            />
                        </div>

                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">Start Date</label>
                            <input
                                type="date"
                                name="start_date"
                                value={formData.start_date}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                            />
                        </div>

                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">End Date</label>
                            <input
                                type="date"
                                name="end_date"
                                value={formData.end_date}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                            />
                        </div>

                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">Min Offer (%)</label>
                            <input
                                type="number"
                                name="offer_percentage_min"
                                value={formData.offer_percentage_min}
                                onChange={handleChange}
                                placeholder="Min %"
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                            />
                        </div>

                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">Max Offer (%)</label>
                            <input
                                type="number"
                                name="offer_percentage_max"
                                value={formData.offer_percentage_max}
                                onChange={handleChange}
                                placeholder="Max %"
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
                            />
                        </div>
                    </div>

                </div>
            </CommonPopupForm>
        </div>
    )
}

export default Promotions
